import { downloadAttachment } from '@/api/attachments';
import type { Attachment } from '@/types/attachment';
import { isPreviewableInBrowser } from '@/utils/file';

interface Params {
  attachment: Attachment;
  onPreview: (attachment: Attachment) => void;
  onDownloaded?: () => void;
}

export const openAttachment = async ({
  attachment,
  onPreview,
  onDownloaded,
}: Params): Promise<void> => {
  if (isPreviewableInBrowser(attachment.name)) {
    onPreview(attachment);
    return;
  }

  try {
    await downloadAttachment(attachment.id, attachment.name);
    onDownloaded?.();
  } catch (error) {
    console.error('Attachment download failed', error);
  }
};
